// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"393":"e72ab5c2","994":"2986b3af"}[chunkId] + ".css";
};